import React from "react";
import "./About.scss";
import TopImage from "../../components/aboutSessions/topImg/TopImage";
import AboutDetails from "../../components/aboutSessions/aboutDetails/AboutDetails";
import AboutNumbers from "../../components/aboutSessions/aboutNumbers/AboutNumbers";
import AboutVideo from "../../components/aboutSessions/aboutVideo/AboutVideo";
import AboutCard from "../../components/aboutSessions/aboutCard/AboutCard";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function About() {
  return (
    <div>
      <TopImage />
      <Breadcrumb />
      <AboutDetails />
      <AboutNumbers />
      <AboutVideo />
      <div id="reviews">
        <AboutCard />
      </div>
    </div>
  );
}
